export const ERROR_MESSAGE_SHOULD_BE_VISIBLE = [
  "Invalid Segment Name",
  "No accessible questions found.",
];
